export default "__VITE_ASSET__9106ed24__"